export const initialAbility = [
  {
    action: 'read',
    subject: 'AppRoot',
  },
  {
    action: 'read',
    subject: 'AuthRoute',
  },
]

export const _ = undefined
